<app-user-restrictions-panel
  [userTypeFilterState]="userTypeFilterState"
  [departmentFilterState]="departmentFilterState"
  [privateLabelFilterState]="privateLabelFilterState"
  entityLabel="template">
</app-user-restrictions-panel>
